<template>
  <XButton
    v-if="grantCorporateTransfer(rightType)"
    block
    type="blank"
    ghost
    class="mt-[16px]"
    @click="onTransferClick"
  >
    {{ $t('dui-gong-zhuan-zhang') }}
  </XButton>
  <XButton block type="blank" ghost class="mt-[16px]" @click="openCustomer">
    {{ $t('lian-xi-ke-fu') }}
  </XButton>
</template>

<script setup lang="ts">
import { useTransferIntercept } from '../useTransferIntercept';
import { useTransferModal } from './transfer-modal';
import XButton from '~/components/xButton/index.vue';
import { orderList } from '~/api';
import { PAY_STATUS, PAY_TYPE, type USER_LEVEL_KEY } from '~/api/interface';
import { usePermission } from '~/hooks/usePermission.ts';
import { TEAM_CREATE_PROVIDES } from '~/pages/teamCreate/constant';
import type { IOrder } from '~/api/interface/order';

defineProps<{
  rightType: USER_LEVEL_KEY;
}>();

const emits = defineEmits(['transfer']);

const srv: any = inject(TEAM_CREATE_PROVIDES);

const { $t } = useNuxtApp();

const { grantCorporateTransfer } = usePermission();

function openCustomer() {
  openCustomerService();
}

const checkExistingTransferOrder = async () => {
  const headers = {
    Authorization: srv.auth,
  };
  const res = await orderList(
    {
      pay_type: PAY_TYPE.TRANSFER,
      status: PAY_STATUS.UNPAID,
      order_type: srv.orderType,
    },
    {
      headers,
    },
  );
  const orderDetail = res.data?.results?.[0] as unknown as IOrder;
  if (orderDetail) {
    useTransferIntercept({
      headers,
      order: orderDetail,
    });
  } else {
    useTransferModal({
      onOk: () => {
        emits('transfer');
      },
    });
  }
};

function onTransferClick() {
  if (srv) {
    checkExistingTransferOrder();
  } else {
    useTransferModal({
      onOk: () => {
        emits('transfer');
      },
    });
  }
}
</script>

<style lang="scss">
.transfer-modal {
  .ant-modal-confirm-title {
    text-align: center;
    padding-top: 19px;
    font-size: 16px;
    color: var(--text-1);
  }
  .ant-modal-confirm-content {
    padding-top: 40px;
    max-width: 100% !important;
    text-align: center;
    font-size: 14px;
    color: var(--text-1);
  }
}
</style>
